import { Stack, Title, Group } from '@mantine/core';
import { RevenueTable } from './RevenueTable';
import { StripeSync } from './StripeSync';

export function RevenuePage() {
  return (
    <Stack gap="md">
      <Group justify="space-between">
        <Title order={2}>Umsätze</Title>
        <StripeSync />
      </Group>
      <RevenueTable />
    </Stack>
  );
}
